import { IconCloseOutline } from '@/components/icons'
import { Button } from '@/components/shadcn/button'
import { SupportPanelState } from '@/layouts/UnityLayout'
import clsx from 'clsx'
import { motion } from 'motion/react'

export type SupportPanelProps = SupportPanelState & {
  children: React.ReactNode
}

const renderTitle = (key = '') => {
  switch (key) {
    case 'data-assets':
      return 'Data Assets'
    case 'data-templates':
      return 'Templates'
    case 'glossary':
      return 'Glossary'
    case 'faq':
      return 'FAQ'
    default:
      return 'Support'
  }
}

export function SupportPanel({ supportPanelView, setSupportPanelView, children }: SupportPanelProps) {
  return (
    <motion.div layout className={clsx('flex flex-col gap-y-5 p-5', { hidden: !supportPanelView })}>
      <motion.div layout className="flex justify-between">
        <motion.h6 layout>{renderTitle(supportPanelView?.key)}</motion.h6>
        <Button variant="ghost" className="size-5" size="icon" onClick={() => setSupportPanelView(undefined)}>
          <IconCloseOutline className="size-4" />
        </Button>
      </motion.div>
      <motion.span layout>{children}</motion.span>
    </motion.div>
  )
}
